import Axios from "../Axios";

// Get all device settings with pagination
export const getDeviceSettings = async (page = 1, limit = 10, searchValue = null) => {
    try {
        const res = await Axios.get(`/attendance-device-setting`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
            params: {
                page: page,
                limit: limit,
                ...(searchValue && { name: searchValue }),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

// Get single device setting
export const getDeviceSetting = async (id) => {
    try {
        const res = await Axios.get(`/attendance-device-setting/show/${id}`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

// Create device setting
export const createDeviceSetting = async (data) => {
    try {
        const res = await Axios.post(`/attendance-device-setting/create`, data, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

// Update device setting
export const updateDeviceSetting = async ({ id, data }) => {
    try {
        const res = await Axios.post(`/attendance-device-setting/update/${id}`, data, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

// Delete device setting
export const deleteDeviceSetting = async (id) => {
    try {
        const res = await Axios.delete(`/attendance-device-setting/delete/${id}`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};
